import Chip from "@mui/material/Chip";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

export default function ReadOnlyChip() {
  return <Chip size="small" icon={<VisibilityOutlinedIcon />} label="Somente leitura" sx={{ bgcolor: "#eceff1", color: "text.secondary", fontWeight: 500 }} />;
}
